'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tab = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactRouterDom = require('react-router-dom');

var _Button = require('@material-ui/core/Button');

var _Button2 = _interopRequireDefault(_Button);

var _styles = require('@material-ui/core/styles');

var _Accent = require('../Accent');

var _Accent2 = _interopRequireDefault(_Accent);

var _constants = require('../constants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = React.createElement(_Accent2.default, null);

var Tab = exports.Tab = function (_React$Component) {
  (0, _inherits3.default)(Tab, _React$Component);

  function Tab() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Tab);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Tab.__proto__ || (0, _getPrototypeOf2.default)(Tab)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isActive: false
    }, _this.handleClick = function () {
      var _this$props = _this.props,
          history = _this$props.history,
          onNavigate = _this$props.onNavigate,
          to = _this$props.to;


      history.push(to);
      onNavigate({
        to: _this.getWrapperPosition()
      });
    }, _this.setActiveState = function (targetProps) {
      var location = targetProps.location,
          to = targetProps.to,
          exact = targetProps.exact;


      var isActive = !!(0, _reactRouterDom.matchPath)(location.pathname, {
        path: (typeof to === 'undefined' ? 'undefined' : (0, _typeof3.default)(to)) === 'object' ? to.pathname : to,
        exact: typeof exact === 'boolean' ? exact : true
      });

      _this.setState({
        isActive: isActive
      });
    }, _this.getWrapperPosition = function () {
      var left = void 0;
      var width = void 0;

      if (_this.wrapper && _this.wrapper.getBoundingClientRect) {
        var boundingRect = _this.wrapper.getBoundingClientRect();
        left = boundingRect.left;
        width = boundingRect.width;
      }

      return {
        left: left,
        width: width
      };
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  } // see flow docs https://flow.org/en/docs/react/refs/

  (0, _createClass3.default)(Tab, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setActiveState(this.props);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.state.isActive) {
        this.props.onNavigate({
          from: this.getWrapperPosition()
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setActiveState(nextProps);
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames,
          _this2 = this;

      var _props = this.props,
          children = _props.children,
          classes = _props.classes,
          isRambling = _props.isRambling,
          showAccent = _props.showAccent;
      var isActive = this.state.isActive;


      var buttonRootClassList = (0, _classnames3.default)(classes.buttonRoot, (_classnames = {}, (0, _defineProperty3.default)(_classnames, classes.isContentRambling, isRambling), (0, _defineProperty3.default)(_classnames, classes.isActive, isActive), _classnames));

      return React.createElement(
        'li',
        {
          className: classes.container,
          ref: function ref(el) {
            _this2.wrapper = el;
          }
        },
        React.createElement(
          _Button2.default,
          {
            classes: {
              root: buttonRootClassList
            },
            onClick: this.handleClick
          },
          children.map(function (line) {
            return React.createElement(
              'span',
              { className: classes.line, key: line },
              line
            );
          }),
          showAccent && isActive && _ref2
        )
      );
    }
  }]);
  return Tab;
}(React.Component);

Tab.defaultProps = {
  classes: {},
  history: {
    push: function push() {}
  },
  location: {
    pathname: ''
  },
  showAccent: false
};


var stylesheet = function stylesheet(_ref3) {
  var _buttonRoot;

  var breakpoints = _ref3.breakpoints,
      palette = _ref3.palette;
  return {
    container: {
      listStyle: 'none'
    },
    buttonRoot: (_buttonRoot = {
      color: palette.primary.contrastText,
      opacity: 0.7,
      display: 'block',
      fontSize: 14,
      height: 48,
      maxWidth: _constants.MAX_TAB_WIDTH,
      padding: 0,
      textAlign: 'center',
      position: 'relative'
    }, (0, _defineProperty3.default)(_buttonRoot, breakpoints.down('md'), {
      paddingLeft: _constants.TAB_PADDING_MAP.SM,
      paddingRight: _constants.TAB_PADDING_MAP.SM
    }), (0, _defineProperty3.default)(_buttonRoot, breakpoints.up('md'), {
      paddingLeft: _constants.TAB_PADDING_MAP.MD,
      paddingRight: _constants.TAB_PADDING_MAP.MD
    }), _buttonRoot),
    isActive: {
      opacity: 1
    },
    isContentRambling: {
      fontSize: 12
    },
    line: {
      display: 'block',
      whiteSpace: 'nowrap',
      '& + &': {
        marginTop: 2
      }
    }
  };
};

exports.default = (0, _styles.withStyles)(stylesheet)(Tab);